import { scrubSentryEvent } from '@payaca/shared-isomorphic/sentry/scrubSentryEvent';
import { sentryDataCollection } from '@payaca/shared-isomorphic/sentry/dataCollection';
import { init, replayIntegration } from '@sentry/react';

if (import.meta.env.VITE_SENTRY_CLIENT_ID) {
  init({
    dataCollection: sentryDataCollection,
    dsn: import.meta.env.VITE_SENTRY_CLIENT_ID,
    environment: import.meta.env.VITE_ENV || import.meta.env.VITE_APP_ENV,
    ignoreErrors: [
      /t.getElementsByTagName/, // ???
      /Cannot read properties of null (reading 'querySelectorAll')/, // trello-smooth-dnd
      /Failed to execute 'removeChild' on 'Node'/, // react-draggable
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    maxValueLength: 1_000, // Avoid truncating really long error messages
    // Strip sensitive values (passwords, tokens, secrets, …) before sending.
    beforeSend: (event) => scrubSentryEvent(event),
    integrations: [replayIntegration({})],
  });
}
